<template>
  <form>
    <div class="row q-col-gutter-md">
      <div class="col col-xs-12 col-md-6 col-lg-6">
        <q-input
            v-model="RoleObj.label"
            :label="$t('acl.role')"
            lazy-rules
            color="input-color"
            :error="RoleObj.errors.has('label')"
            :error-message="RoleObj.errors.get('label')"
            :rules="[ val => val && val.length > 0 || 'Role field is required']"
            placeholder="ex: Admin Assistant"
        />
      </div> <!-- Role LABEL -->
      <div class="col col-xs-12 col-md-6 col-lg-6">
        <q-input
            v-model="RoleObj.name"
            :label="$t('acl.tag')"
            lazy-rules
            color="input-color"
            :error="RoleObj.errors.has('name')"
            :error-message="RoleObj.errors.get('name')"
            :rules="[ val => val && val.length > 0 || 'Tag field is required']"
            placeholder="Ex: 'admin-assistant'"
            dir="ltr"
        />
      </div> <!-- NAME -->
    </div>
    <p class="text-weight-bold q-mt-lg">{{ $t('acl.permissions') }}:</p>
    <div class="row q-col-gutter-md">
      <div class="col text-center" v-if="loading">
        <q-spinner-dots color="primary" size="30px"/>
      </div>
      <div class="col" v-else>
        <div class="row">
          <div class="col-12">
            <q-checkbox
                :label="$t('acl.select_all_permissions')"
                indeterminate-value="maybe"
                :value="allPermissionsSelected"
                color="input-color"
                @input="selectAll"/>
          </div>

          <div class="col-12">
            <div class="row q-col-gutter-md">
              <div class="col-md-4 col-xs-12" v-for="(permissions, index) in permissionGroups" :key="index">
                <q-chip square color="grey-4" text-color="black" style="margin-bottom: -5px">
                  <b>{{index.ucfirst()}}</b>
                </q-chip>
                <div class="permission-card">
                  <q-checkbox
                      :label="$t('acl.select_all_permissions_in_this_column')"
                      :value="scopeSelected(index)"
                      color="input-color"
                      class="full-width bg-grey-4"
                      @input="selectAllOfScope(index)"/>
                  <div v-for="(permission, index) in permissions" :key="index">
                    <q-checkbox
                        :val="permission.name"
                        :label="permission.label"
                        v-model="RoleObj.permissions"
                        color="input-color"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: 'Form',
  model: {
    prop: 'RoleObj'
  },
  props: {
    RoleObj: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    permissions: {
      type: Array,
      default: []
    }
  },
  computed: {
    allPermissionsSelected() {
      if (!this.RoleObj.permissions.length) {
        return false
      } else if (this.RoleObj.permissions.length !== this.permissions.flat().length) {
        return 'maybe'
      }

      return true;
    }
  },
  data() {
    return {
      permissionGroups: []
    }
  },
  methods: {
    provide_permissions(value) {
      this.$emit('load_permissions', value);
    },
    selectAll() {
      if (!this.allPermissionsSelected) {
        this.RoleObj.permissions = this.permissions.flat().map(item => item.name)
      } else {
        this.RoleObj.permissions = []
      }
    },
    scopeSelected(scope) {
      if (!this.RoleObj.permissions.length) {
        return false;
      }
      const selected_count = this.RoleObj.permissions.filter(item => item.split('.')[0] === scope).length

      if (!selected_count)
        return false;

      return selected_count === this.permissionGroups[scope].length ? true : 'maybe';
    },
    selectAllOfScope(scope) {
      if (this.scopeSelected(scope) === false) {
        this.RoleObj.permissions.unshift(...this.permissionGroups[scope].map(item => item.name))
      } else {
        this.RoleObj.permissions = this.RoleObj.permissions.filter(item => item.split('.')[0] !== scope)
      }
    },
    submit() {
      this.$emit('submit')
    },
  },
  watch: {
    permissions(value) {
      this.permissionGroups = value.reduce((perm, curr) => {
        if (!perm[curr.name.split('.')[0]]) perm[curr.name.split('.')[0]] = []; //If this type wasn't previously stored
        perm[curr.name.split('.')[0]].push(curr);
        return perm;
      }, {});
      this.RoleObj.permissions = value.filter(v => v.checked === true).map(v => v.name);
    }
  },
  updated() {
    this.$emit('change', this.RoleObj)
  },
  mounted() {
  },
  components: {},
}
</script>

<style lang="css" scoped>
.permission-card {
  border: 1px solid rgba(0, 0, 0, .125);
  border-radius: .25rem;
}
</style>
